import React, { Component } from 'react';
import { connect } from 'react-redux';
import api from '../../axios-local-api';
import Confirm from '../../components/UI/Confirm/Confirm';
import Error from '../../components/UI/Error/Error';
import Modal from '../../components/UI/Modal/Modal';
import Spinner from '../../components/UI/Spinner/Spinner';
import Success from '../../components/UI/Success/Success';
import Switch from '../../components/UI/Switch/Switch';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import classes from './Upnp.css';


export class Upnp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      success:false,
      error:false,
      action:null,
      checked:this.props.originalUpnp.enabled,
      confirmModal:false,
      result: ''
    }
    this.handleToggleUpnp = this.handleToggleUpnp.bind(this);
  }


  componentDidMount() {
  }
  componentWillUpdate() {

  }
  componentDidUpdate() {

  }
  handleToggleUpnp() {
    // this.onOpenModal('Change UPnP');
    if (!this.state.checked) {
      const modalContent = (<div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <h2 style={{ whiteSpace: 'nowrap', marginBottom:'5px' }}>Enable UPnP?</h2>
        <p id = 'upnpMsg' style={{ fontWeight: 'normal', textAlign: 'center', margin:'5px' }}>It may take up to 120 seconds for changes to occur on the customer router, and the public IP address may change.<b>During this time, the customer network may reboot.</b></p>
        <p style={{ fontWeight: 'normal', margin: 0, textAlign: 'center' }}>Are you sure you want to proceed?</p>

      </div>)
      this.onOpenModal(modalContent, 'change upnp');
    } else {
      const modalContent = (<div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <h2 style={{ whiteSpace: 'nowrap', marginBottom:'5px' }}>Disable UPnP?</h2>
        <p id ='upnpMsg' style={{ fontWeight: 'normal', textAlign: 'center', margin:'5px' }}>It may take up to 120 seconds for changes to occur on the customer router, and the public IP address may change.<b>During this time, the customer network may reboot.</b></p>
        <p style={{ fontWeight: 'normal', margin: 0, textAlign: 'center' }}>Are you sure you want to proceed?</p>
      </div>)
      this.onOpenModal(modalContent, 'change upnp');
    }


    this.setState((state) => ({ checked: !state.checked }));

  }
  successErrorResetHandler = () => {
    this.setState({ error:false,success:false });
    this.props.onResetUpnpErrorSuccess()
  }
  confirmModalConfirmHandler = () => {
    this.props.onChangeUpnp( this.state.checked );
    this.closeModal('dontreset');
  }
  confirmModalCancelHandler = () => {
    // this.props.resetUpnp()
    this.setState({ confirmModal:false, checked: this.props.originalUpnp.enabled });

  }
  closeModal= (event) => {
    this.setState({ confirmModal:false });
    if (event !== 'dontreset') {
      this.setState({ checked: this.props.originalUpnp.enabled })
    }
  }
  onOpenModal= (result, action) =>{
    this.setState({
      confirmModal:true,
      action,
      result
    })
  }


  render() {
//  console.log(this.state, 'upnp');
    if(this.props.error && !this.state.error){
      this.setState({ error:true })
      this.props.onResetUpnpErrorSuccess()
    }
    if(this.props.success && !this.state.success){
      this.setState({ success:true })
      this.props.onResetUpnpErrorSuccess()
    }
    if (!this.props.loaded || this.props.loading) {

      return (
          <Spinner />
      )
    } else if(!this.props.realUpnp){
return (
  <Box>
  <div className={classes.Upnp}>
    <div className={classes.TitleArea}>
    <div> UPNP </div>
    <div style={{ color:'gray' }}>
                There is no UPNP information available at this time
    </div>
    </div>

  </div>

</Box>
)
    }else{

      return (
        <Box>
          <div className={classes.Upnp}>
            <div id = 'UPnP' className={classes.TitleArea}>
              <h3> UPnP </h3>
              <Switch id = 'UPnPToggle'
                aria-checked={this.state.checked}
                aria-label="Toggle UPNP"
                onChange={this.handleToggleUpnp}
                checked={this.state.checked}
              />
            </div>

          </div>
          <Modal deviceGroupConfirmation="true" show={this.state.confirmModal} modalClosed={this.closeModal}>
           <Confirm id = {'UPnPConfirm'}
           action={this.state.action}
           result={this.state.result}
           deviceGroupConfirmation
           confirm={this.confirmModalConfirmHandler}
           cancel={this.confirmModalCancelHandler}
           cancelButtonLabel="Cancel"
           confirmButtonLabel={this.state.checked ? 'Enable' : 'Disable'}
           hideActionText={true}
           />
        </Modal>
        <Modal show={this.state.error} modalClosed={this.successErrorResetHandler}>
           <Error id = {'UPnPError'} showOldView/>
        </Modal>
        <Modal show={this.state.success} modalClosed={this.successErrorResetHandler}>
           <Success id = {'UPnPSuccess'}/>
        </Modal>
        </Box>
      )
    }
  }
}

const mapStateToProps = (state => {
  return {
    loading: state.upnp.loading,
    loaded: state.upnp.loaded,
    account: state.settings.account,
    isAuthenticated: state.auth.token !== null, isPinxt: state.auth.pToken !== null,
    realSettings:state.settings.realSettings,
    isDummy:state.auth.isDummy,
    success:state.upnp.success,
    realUpnp:state.upnp.realUpnp,
    error:state.upnp.error
  };
});

const mapDispatchToProps = (dispatch) => {
  return {
    onChangeUpnp: ( newVal ) => dispatch( actions.changeUpnp( newVal )),
    onResetUpnpErrorSuccess: () => dispatch(actions.resetUpnpErrorSuccess())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(Upnp, api));
